var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.5C12.2761 0.5 12.5 0.723858 12.5 1V23C12.5 23.2761 12.2761 23.5 12 23.5C11.7239 23.5 11.5 23.2761 11.5 23V1C11.5 0.723858 11.7239 0.5 12 0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67157 5.67157C7.42172 4.92143 8.43913 4.5 9.5 4.5H17C17.2761 4.5 17.5 4.72386 17.5 5C17.5 5.27614 17.2761 5.5 17 5.5H9.5C8.70435 5.5 7.94129 5.81607 7.37868 6.37868C6.81607 6.94129 6.5 7.70435 6.5 8.5C6.5 9.29565 6.81607 10.0587 7.37868 10.6213C7.94129 11.1839 8.70435 11.5 9.5 11.5H14.5C15.5609 11.5 16.5783 11.9214 17.3284 12.6716C18.0786 13.4217 18.5 14.4391 18.5 15.5C18.5 16.5609 18.0786 17.5783 17.3284 18.3284C16.5783 19.0786 15.5609 19.5 14.5 19.5H6C5.72386 19.5 5.5 19.2761 5.5 19C5.5 18.7239 5.72386 18.5 6 18.5H14.5C15.2956 18.5 16.0587 18.1839 16.6213 17.6213C17.1839 17.0587 17.5 16.2956 17.5 15.5C17.5 14.7044 17.1839 13.9413 16.6213 13.3787C16.0587 12.8161 15.2956 12.5 14.5 12.5H9.5C8.43913 12.5 7.42172 12.0786 6.67157 11.3284C5.92143 10.5783 5.5 9.56087 5.5 8.5C5.5 7.43913 5.92143 6.42172 6.67157 5.67157Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/payment.1e16fe01d37aef01056cc3f6381addb3.svg";